// Account focus request bus.
//
// Used so deep-linked diagnostics (e.g. PurchaseConfidenceCard auth-user path)
// can ask the app to switch to the Account screen and open / scroll to a
// specific editable section (brand fits, sizes, lookbook model, etc.).
//
// Producers call `requestAccountFocus(section)`.
// The top-level `Like2FitApp` subscribes once, switches screen, and forwards
// the focus request as a prop to the Account screen, which auto-opens the
// matching sheet and scrolls / pulses the matching row.

export type AccountFocusSection = "brand_fit" | "size" | "model" | "personalisation";

export interface AccountFocusRequest {
  section: AccountFocusSection;
  nonce: number;
}

type Listener = (req: AccountFocusRequest) => void;

const listeners = new Set<Listener>();

export function requestAccountFocus(section: AccountFocusSection): void {
  const req: AccountFocusRequest = { section, nonce: Date.now() };
  listeners.forEach((l) => {
    try { l(req); } catch (e) { console.error("[accountFocus] listener error", e); }
  });
}

export function subscribeAccountFocus(listener: Listener): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
